import { render, staticRenderFns } from "./CancelTransaction.vue?vue&type=template&id=a2ed3646&scoped=true"
import script from "./CancelTransaction.vue?vue&type=script&lang=js"
export * from "./CancelTransaction.vue?vue&type=script&lang=js"
import style0 from "./CancelTransaction.vue?vue&type=style&index=0&id=a2ed3646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ed3646",
  null
  
)

export default component.exports